import * as React from 'react';
import { useRef} from 'react'
import { gold } from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import {Stack} from "@mui/material";
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HotelesCardsSearch from './hotelCardSearch'
import Carousel from './hotelCarousel'



// Genero una base de datos de Hoteles Ficticios
function createHotelCard(
  id: number,
  img: string,
  title: string,
  description: string,
  link: string,
) {
  return { id, img, title, description, link};
}

const hotelesCards = [
  createHotelCard(
    1,
    'https://media.staticontent.com/media/pictures/c915a8f3-8575-49b8-a43d-4b3f185ca037',
    'Sheraton',
    'Sheraton Buenos Aires Hotel & Convention Center se sitúa en Buenos Aires. Dispone de piscina al aire libre de temporada, wi-fi gratis en zonas comunes y servicio de spa, así como sauna.',
    'https://www.despegar.com.ar/hoteles/h-242179/sheraton-buenos-aires-hotel-convention-center-buenos+aires'
  ),
  createHotelCard(
    2,
    'https://media.staticontent.com/media/pictures/89631ae8-b77c-4348-aa95-a35482200f29/853x380?op=TRUNCATE&enlarge=false&gravity=ce_0_0&quality=80&dpr=1.5',
    'HR Luxor Buenos Aires',
    'El HR Luxor Buenos Aires está ubicado en el centro de Buenos Aires. Dispone de una terraza con bañera de hidromasaje, sauna y gimnasio. El Diagonal Restaurant, con vistas a la ciudad, ofrece ensaladas, carnes y pastas.',
    'https://www.despegar.com.ar/hoteles/h-241453/hr-luxor-buenos-aires-buenos+aires'
  ),
  createHotelCard(
    3,
    'https://media.staticontent.com/media/pictures/7f2ec7fb-d7b1-4c38-814d-1d01ce99131a/853x380?op=TRUNCATE&enlarge=false&gravity=ce_0_0&quality=80&dpr=1.5',
    'Exe Hotel Colon',
    'Frente a la Avenida 9 de Julio, a sólo 100 m del Obelisco y a 3 minutos a pie del Teatro Colón, el Exe Hotel Colón ofrece un variado desayuno buffet y Wi-Fi gratuito en el centro de Buenos Aires. Se sitúa a 5 minutos caminando de la Peatonal Florida y a 7.5 km del Aeroparque Internacional Jorge Newbery. ',
    'https://www.despegar.com.ar/hoteles/h-240873/exe-hotel-colon-buenos+aires'
  ),
  createHotelCard(
    4,
    'https://media.staticontent.com/media/pictures/64a36029-c4cf-45d6-a925-9b0597ed384f/853x380?op=TRUNCATE&enlarge=false&gravity=ce_0_0&quality=80&dpr=1.5',
    'Savoy Hotel',
    'Con arquitectura de estilo neobarroco, El Savoy Hotel está ubicado en Buenos Aires, a 500 m de la zona de teatros y restaurantes de la Avenida Corrientes, a 20 minutos a pie del Obelisco y a 1.5 km del Teatro Colón. Se encuentra a 300 m de la estación Callao de la línea B, que conecta con Puerto Madero y el distrito financiero en 10 minutos y a 400 m de la estación Congreso de la línea A, que llega al Café Tortoni, la Plaza de Mayo y la peatonal Florida en el mismo tiempo. El Aeroparque Internacional Jorge Newbery está a 7.5 km del hotel, que dispone de Wi-Fi gratuito.',
    'https://www.despegar.com.ar/hoteles/h-242301/savoy-hotel-buenos+aires'
  ),
];



//-------------------- Funcion principal exportada --------------------


export default function GestionarHoteles () {

  return (
    <Box>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 5, sm: 5 },
        }}
      >
        <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
          <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
            <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
              <HotelesCardsSearch/>
              <Button sx={{m:1, color: "white", backgroundColor: gold[500], height:55, width: "auto"}} type='submit' color='primary' variant="contained"  ><SearchIcon/></Button>
            </Box>
          </Box>
          <Box sx={{display: 'flex',flexDirection: 'column',alignSelf: 'center',textAlign: 'center',}}>
            <Carousel hotelesCards={hotelesCards} showButtons/>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
